export function setupAttachmentWarning(): void {
  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target as HTMLFormElement;

      // if it's not a form we're watching,
      // or it already has a warning added, allow submit
      if (
        !form.hasAttribute("data-intercept-submit") ||
        form.querySelector("[data-attachment-submit-warning]")
      )
        return;

      // Find all file inputs with data-attachment-input attribute
      const attachmentInputs = form.querySelectorAll(
        'input[type="file"][data-attachment-input="true"]',
      ) as NodeListOf<HTMLInputElement>;

      // Check if any attachment inputs have files
      const hasFiles = Array.from(attachmentInputs).some(
        (input) => input.files && input.files.length > 0,
      );

      // If files are attached, allow submit
      if (hasFiles) return;

      // If no files are attached, show warning
      const warningSpan = document.createElement("span");
      warningSpan.setAttribute("data-attachment-submit-warning", "true");
      warningSpan.className = "text-warning d-block mb-2";
      warningSpan.textContent =
        "Warning: You are about to submit without any attachments.";

      const submitButton = form.querySelector(
        'button[type="submit"]',
      ) as HTMLButtonElement;

      // Insert warning above the submit button, or above the form if button not found
      submitButton.parentNode?.insertBefore(warningSpan, submitButton ?? form);

      event.preventDefault();
    },
    { capture: true },
  );
}
